$(function() {
	var meg = {
		el: {
			body: $('body'),
			modal: $('.js-modal-meg'),
			closeModal: $('.js-close-modal')
		},
		
		events: function events() {
			var _this = this;

			this.el.closeModal.on('click', function() {
				_this.el.body.removeAttr('style')
				_this.el.modal.removeClass('is-active');
			});
		},
		
		init: function init() {
			this.events();
		}
	};
	meg.init();
});